import o from "react";
import { Check as _ } from "@olxbr/ds-icons";
import { Text as y } from "../../../Text/Text.js";
import { cls as m } from "../../../../helpers/cls.js";
var w = Object.defineProperty,
  k = Object.defineProperties,
  g = Object.getOwnPropertyDescriptors,
  i = Object.getOwnPropertySymbols,
  p = Object.prototype.hasOwnProperty,
  d = Object.prototype.propertyIsEnumerable,
  u = (t, l, e) => l in t ? w(t, l, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[l] = e,
  C = (t, l) => {
    for (var e in l || (l = {})) p.call(l, e) && u(t, e, l[e]);
    if (i) for (var e of i(l)) d.call(l, e) && u(t, e, l[e]);
    return t;
  },
  j = (t, l) => k(t, g(l)),
  E = (t, l) => {
    var e = {};
    for (var r in t) p.call(t, r) && l.indexOf(r) < 0 && (e[r] = t[r]);
    if (t != null && i) for (var r of i(t)) l.indexOf(r) < 0 && d.call(t, r) && (e[r] = t[r]);
    return e;
  };
const I = t => {
  var l = t,
    {
      filteredItems: e,
      selectedItems: r,
      handleCheckboxChange: f,
      showDropdownList: b,
      isOpen: v,
      sizeMaxOverflow: x
    } = l,
    h = E(l, ["filteredItems", "selectedItems", "handleCheckboxChange", "showDropdownList", "isOpen", "sizeMaxOverflow"]);
  return !b || !e ? null : o.createElement("ul", j(C({
    className: "olx-multiselect__options",
    role: "listbox"
  }, h), {
    style: {
      "--size-max-overflow": "calc(".concat(x, " + 2px)")
    }
  }), e.length === 0 && o.createElement(y.BodyMedium, {
    className: "olx-multiselect__empty-text"
  }, "Nenhum item encontrado"), e == null ? void 0 : e.map((a, O) => {
    var n;
    const c = ((n = a.value) == null ? void 0 : n.toString()) || "",
      s = r.includes(c);
    return o.createElement("button", {
      "aria-posinset": O + 1,
      "aria-setsize": e.length,
      key: a.id,
      role: "option",
      "aria-selected": s,
      onClick: () => f(c),
      disabled: a.disabled,
      className: m("olx-multiselect__check-button", "ds-multiselect-option"),
      tabIndex: v ? 0 : -1
    }, o.createElement("span", {
      className: m("olx-multiselect__check-icon", s ? "olx-multiselect__check-icon--visible" : "olx-multiselect__check-icon--hidden")
    }, o.createElement(_, null)), a.label);
  }));
};
export { I as Options };